// Import RoleType enum to use as keys
import { RoleType } from '../types/enums';

/**
 * Configuration for invitation related functionality
 */

// How long invitations remain valid after creation
export const INVITATION_TOKEN_EXPIRY_DAYS = 30;

// Add attestation token expiry days
export const ATTESTATION_TOKEN_EXPIRY_DAYS = 7;

// Maximum number of invitations that can be sent for each role
export const MAX_INVITES_PER_ROLE: Record<RoleType | 'DEFAULT', number> = {
  [RoleType.ENDORSER]: 10,
  [RoleType.ASSESSOR]: 5,
  [RoleType.CANDIDATE]: 1,
  [RoleType.MANAGER]: 3,
  [RoleType.SENIOR_LEADER]: 1,
  [RoleType.HR]: 2,
  [RoleType.BAR_RAISER]: 10,
  [RoleType.OPPORTUNITY_AUTHOR]: 10,
  DEFAULT: 1
};

// URL path patterns for redirects after invitation acceptance
export const ROLE_REDIRECT_PATHS: Record<RoleType | 'DEFAULT', string> = {
  [RoleType.ENDORSER]: '/packets/:packetId?tab=endorsements',
  [RoleType.ASSESSOR]: '/packets/:packetId?tab=blinded',
  [RoleType.MANAGER]: '/packets/:packetId',
  [RoleType.SENIOR_LEADER]: '/packets/:packetId',
  [RoleType.CANDIDATE]: '/packets/:packetId',
  [RoleType.HR]: '/packets/:packetId',
  [RoleType.BAR_RAISER]: '/packets/:packetId?tab=bar-raiser',
  [RoleType.OPPORTUNITY_AUTHOR]: '/packets/:packetId?tab=opportunities',
  DEFAULT: '/packets/:packetId'
}; 